import React from "react";
import {message} from "antd";
import ErrorPage from "./pages/Error/ErrorPage.jsx";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        const userAgent = navigator.userAgent || "";

        if (error && error.message && error.message.includes("Method not found") && userAgent.includes("Android")) {
            console.warn("Ошибка Method not found:", error, info.componentStack);
            return;
        }
        if (error && error.message) {
            message.error('An error occurred: ' + error.message + (info ? ` - ${info.componentStack}` : '') || 'Unknown error').then(r => r);
            this.setState({ error });
        }
    }

    render() {
        if (this.state.hasError) {
            return <ErrorFallback />;
        }

        return this.props.children;
    }
}


const ErrorFallback = () => {

    return (
        <ErrorPage/>
    );
};

export default ErrorBoundary;